import React, { FunctionComponent, useEffect } from "react";
import { server, token } from "../utils";
import { QRCode } from "antd";

const QrcodePage:FunctionComponent = () => {
  useEffect(() => {
    console.log(`florianhjautotrading://initialize?server=${server}&token=${token}`)
  })
  return <>
    <QRCode value={`florianhjautotrading://initialize?server=${server}&token=${token}`} />
  </>
}

export { QrcodePage }